import React, { Component } from 'react'
import PropTypes from 'prop-types'

class WishlistResume extends Component {
  render () {
    return (
      <li className='px-0 py-0 mb-1 profile-wishlist'>
        <div className='row align-items-center h-100 mx-0'>
          <button className='wishlist-button col mr-auto btn btn-flat btn-sm btn-icon color-brand-1 txt-font-body txt-initial txt-body'>
            <i className='icon icon_wishlist color-brand-1' />
            Favoritos
          </button>
          <div className='wishlist-count col-auto mx-2 my-1 txt-center bg-ui-4 color-brand-1 radius-circle'>
            {this.props.count}
          </div>
        </div>
      </li>
    )
  }
}

WishlistResume.propTypes = {
  count: PropTypes.number
}

export default WishlistResume



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/WishlistResume/WishlistResume.js